import { ComingSoon } from '~/elements/ComingSoon'
import { AddKnowledgeSourceButton } from './AddKnowledgeSourceButton'
import { useAddKnowledgeSourceStepContext } from './AddKnowledgeSourceStepContext'

export const SelectContentStep = () => {
  const { changeStep } = useAddKnowledgeSourceStepContext()

  return (
    <div className="flex max-h-[calc(100vh-300px)] w-full flex-col gap-10 text-start @container">
      <div className="grid grid-cols-1 gap-x-4 gap-y-6 @xl:grid-cols-2">
        <h1 className="col-span-full text-base font-bold text-foreground">Import Content</h1>
        <AddKnowledgeSourceButton type="document" onClick={() => changeStep('upload_documents')} />
        <AddKnowledgeSourceButton type="rich-text" onClick={() => changeStep('upload_rich_text')} />
      </div>
      <div className="grid grid-cols-1 gap-x-4 gap-y-6 @xl:grid-cols-2">
        <h1 className="col-span-full text-base font-bold text-foreground">Sync Content</h1>
        <AddKnowledgeSourceButton type="web-page" onClick={() => changeStep('sync_website')} />
        <ComingSoon>
          <AddKnowledgeSourceButton type="notion" onClick={() => {}} />
        </ComingSoon>
        <ComingSoon>
          <AddKnowledgeSourceButton type="google-drive" onClick={() => {}} />
        </ComingSoon>
        <ComingSoon>
          <AddKnowledgeSourceButton type="confluence" onClick={() => {}} />
        </ComingSoon>
        {/* This is to add padding when we reach end of scroll */}
        <span></span>
      </div>
    </div>
  )
}
